import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const cartAdapter = createEntityAdapter({});

const cartSlice = createSlice({
  name: "cartSlice",
  initialState: cartAdapter.getInitialState({
    totalPrice: 0,
  }),
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;
      const existingItem = state.entities[item.id];

      if (existingItem) {
        existingItem.quantity += 1;
        state.totalPrice += item.price;
      } else {
        cartAdapter.addOne(state, item);
        state.totalPrice += item.price;
      }
    },
    removeFromCart: (state, action) => {
      const id = action.payload;
      const existingItem = state.entities[id];

      if (existingItem) {
        state.totalPrice -= existingItem.price * existingItem.quantity;
        cartAdapter.removeOne(state, id);
      }
    },
    addQuantity: (state, action) => {
      const id = action.payload;
      const existingItem = state.entities[id];

      if (existingItem) {
        // state.totalPrice -= existingItem.quantity * existingItem.price;
        existingItem.quantity = existingItem.quantity + 1;
        state.totalPrice += existingItem.price;
      }
    },
    subQuantity: (state, action) => {
      const id = action.payload;
      const existingItem = state.entities[id];

      if (existingItem && existingItem.quantity > 1) {
        existingItem.quantity = existingItem.quantity - 1;
        state.totalPrice -= existingItem.price;
      }
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const existingItem = state.entities[id];

      if (existingItem) {
        const quantityDiff = quantity - existingItem.quantity;
        state.totalPrice += quantityDiff * existingItem.price;
        existingItem.quantity = quantity;
      }
    },
    clearCart: (state) => {
      cartAdapter.removeAll(state);
      state.totalPrice = 0;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  addQuantity,
  subQuantity,
  updateQuantity,
  clearCart,
} = cartSlice.actions;

// Export selectors generated by createEntityAdapter
export const {
  selectAll: selectAllCartItems,
  selectById: selectCartItemById,
  selectIds: selectCartItemIds,
} = cartAdapter.getSelectors((state) => state.sale.cartSlice);

export default cartSlice.reducer;
